import React, { useState, useEffect } from 'react';
import styles from '../../styles/BuildingPreviews/BuildingDetails.module.css';
import BuildingOverview from './BuildingOverview';
import Community from './Community';
import UnitList from './UnitList';
import UnitDetails from '../UnitDetails/UnitDetails';
import RoommateGroupActions from './RoommateGroupActions';
import ApprovalGauge from './ApprovalGauge'

const API_BASE_URL = import.meta.env.VITE_API_URL;

const BuildingDetails = ({ building, onClose }) => {
  const [activeTab, setActiveTab] = useState('details');
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [favoriteStatus, setFavoriteStatus] = useState(null);
  
  console.log(building);

  const roommateStatuses = [
    { name: 'Alice', status: 'liked', date: 'Mar 1' },
    { name: 'Bob', status: 'pending' },
    { name: 'Charlie', status: 'liked', date: 'Feb 28' },
    { name: 'Dana', status: 'pending' },
  ];
  
   const userId = localStorage.getItem('tenantUserId'); // Clearly retrieve tenantUserId from local storage


  useEffect(() => {
    const fetchFavoriteStatus = async () => {
      const res = await fetch(`${API_BASE_URL}/users/${userId}/favorites/Building/${building.BuildingID}`);
      const data = await res.json();
      setFavoriteStatus(data.preference);
    };

    fetchFavoriteStatus();
  }, [userId, building.BuildingID]);
  
  const handleFavorite = async (preference) => {
    await fetch(`${API_BASE_URL}/users/${userId}/favorites`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ itemType: 'Building', itemId: building.BuildingID, preference }),
    });

    setFavoriteStatus(preference);
  };
  
  const handleFavoriteClick = async (preference) => {
    const method = favoriteStatus === preference ? 'DELETE' : 'POST';

    await fetch(`${API_BASE_URL}/users/${userId}/favorites`, {
      method: method,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        itemType: 'Building',
        itemId: building.BuildingID,
        preference: preference
      })
    });

    // Update local state accordingly
    setFavoriteStatus(prev => prev === preference ? null : preference);
  };


	const mockCommunityData = {
	  walkScore: 85,
	  transitScore: 78,
	  bikeScore: 92,
	  communityDescription: 'Nestled between Harvard Square and Central Square, this vibrant Cambridge neighborhood blends historic charm with modern urban energy.',
	  nearbySchools: [
		{ name: "Cambridge High School", distance: "0.8 miles", rating: "8/10" },
		{ name: "Harvard Primary", distance: "1.2 miles", rating: "9/10" },
	  ],
	  keyLocations: [
		{ name: "Harvard University", travelTime: "10 min by transit" },
		{ name: "Nearest Grocery Store", travelTime: "5 min walk" },
	  ],
	  essentials: [
		{ type: "Grocery Store", name: "Whole Foods Market" },
		{ type: "Pharmacy", name: "CVS Pharmacy" },
	  ]
	};


  const handleSuggestToGroup = () => alert('Suggested to the group!');
  const handleRequestTour = () => alert('Tour request sent!');

  const handleViewUnitDetails = (unit) => {
    setSelectedUnit(unit);
    setActiveTab('unitDetails');
  };
  
   const handleReturnToUnits = () => {
    setSelectedUnit(null);
    setActiveTab('units');
  };

  const paddedBuilding = {
    rating: building.rating ?? 4.7,
    reviewCount: building.reviewCount ?? 28,
    startingPrice: building.startingPrice ?? 2500,
    unitsAvailable: building.unitsAvailable ?? 5,
    ...building,
  };

  const renderActiveTab = () => {
    switch (activeTab) {
      case 'details':
        return <BuildingOverview building={paddedBuilding} />;
      case 'community':
        return <Community communityData={mockCommunityData} />;
       case 'units':
			return <UnitList units={building.Units} onViewDetails={(unit) => {
			  setActiveTab('unitDetails');
			  setSelectedUnit(unit);
			}} />;
		  case 'unitDetails':
			return <UnitDetails unit={selectedUnit} onReturn={handleReturnToUnits} />;
      default:
        return null;
    }
  };

  const handleViewDetails = (unit) => {
    setActiveTab('unitDetails');
    setSelectedUnit(unit);
  };
  
  return (
    <div className={styles.detailsModal} onClick={onClose}>
      <div className={styles.detailsContent} onClick={(e) => e.stopPropagation()}>
        {/* Header and Roommate Section (unchanged) */}
		<div className={styles.detailsHeader}>
		  <div className={styles.addressAndInfo}>
			<div className={styles.addressSection}>
			  <h2 className={styles.addressTitle}>📍 {building.Address}</h2>
			  <p className={styles.addressSubtitle}>📌 {building.City}, {building.State}</p>

			  <div className={styles.headerQuickInfo}>
				<p>⭐ {paddedBuilding.rating} ({paddedBuilding.reviewCount} reviews) |
				💰 From ${paddedBuilding.startingPrice}/month </p>
				<p>{paddedBuilding.unitsAvailable > 0 ? '✅ Units Available' : '⛔ No Availability'}</p>
			  </div>

			  <div className={styles.interactionButtons}>
				  <button
					className={`${styles.iconBtn} ${favoriteStatus === 'Favorite' ? styles.selected : ''}`}
					onClick={() => handleFavoriteClick('Favorite')}
				  >
				  ❤️ Favorite
				</button>
				  <button
					className={`${styles.iconBtn} ${favoriteStatus === 'Dislike' ? styles.selected : ''}`}
					onClick={() => handleFavoriteClick('Dislike')}
				  >
				  👎 Dislike
				</button>
				<button className={`${styles.iconBtn} ${styles.shareBtn}`}>
				  🔗 Share
				</button>
			  </div>
			</div>

			<div className={styles.gaugeContainer}>
			  <ApprovalGauge low={60} high={85} />
			</div>
		  </div>

		  <RoommateGroupActions
			roommateStatuses={roommateStatuses}
			onSuggestToGroup={handleSuggestToGroup}
			onRequestTour={handleRequestTour}
		  />
		</div>


        {/* Tabs Navigation (unchanged) */}
        <nav className={styles.tabs}>
          <button
            className={`${styles.tabButton} ${activeTab === 'details' ? styles.active : ''}`}
            onClick={() => setActiveTab('details')}
          >
            Building Details
          </button>
          <button
            className={`${styles.tabButton} ${activeTab === 'community' ? styles.active : ''}`}
            onClick={() => setActiveTab('community')}
          >
            Community
          </button>
          <button
            className={`${styles.tabButton} ${activeTab === 'units' ? styles.active : ''}`}
            onClick={() => setActiveTab('units')}
          >
            Units
          </button>
          <div
            className={styles.tabIndicator}
            style={{
              left: activeTab === 'details' ? '0%' : activeTab === 'community' ? '33.333%' : '66.666%',
            }}
          />
        </nav>

        {/* Fully Dynamic Content Below Tabs */}
        <div className={styles.tabContent}>
          {renderActiveTab()}
        </div>
      </div>
    </div>
  );
};

export default BuildingDetails;
